"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MobileBottomNavigation = _interopRequireDefault(require("./MobileBottomNavigation"));
var _headerContext = require("./headerContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MobileBottomContent(_ref) {
  let {
    onClickCategories,
    onClickHome,
    hasCategories
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, _ref2 => {
    let {
      state
    } = _ref2;
    if (state.searching) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_MobileBottomNavigation.default, {
      onClickCategories: onClickCategories,
      hasCategories: hasCategories,
      onClickHome: onClickHome
    });
  });
}
MobileBottomContent.propTypes = {
  onClickHome: _propTypes.default.func.isRequired,
  onClickCategories: _propTypes.default.func.isRequired,
  hasCategories: _propTypes.default.bool
};
MobileBottomContent.defaultProps = {
  hasCategories: false
};
var _default = exports.default = MobileBottomContent;